var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"containerApp is-flex is-flex-direction-column container.is-fullhd"},[_c('TopLine'),_c('div',{staticClass:"is-flex-grow-1"},[_c('router-view')],1),_c('PortalFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }